// ENG-4154: prime the IdentityState store directly (single source of truth).
import { primeLinkedAgentId } from '#~/electron/identity-store.js';
import { queryClient, queryKeys } from '#~/react-query/index.js';
import type { Agent } from '@studio/models/agent';

export const primeMachineAgentCache = (bridgeId: Agent['id']): void => {
  // Keep bridge identity in sync across the IdentityState store and React Query
  // before the room UI renders.
  primeLinkedAgentId(bridgeId);
  queryClient.setQueryData(queryKeys.machineAgentId(), bridgeId);
};
